import React from 'react';
import CodeMirror from '@uiw/react-codemirror';
import { html } from '@codemirror/lang-html';

function CodeEditor({ 
  value, 
  onChange, 
  placeholder, 
  rows = 50, 
  className = '',
  language = 'html',
  height = '300px'
}) {
  const handleChange = (val) => {
    // Ensure val is a string and pass it directly
    const stringValue = typeof val === 'string' ? val : '';
    onChange({ target: { value: stringValue } });
  };

  return (
    <div className={`code-editor-container ${className}`}>
      <CodeMirror
        value={typeof value === 'string' ? value : ''}
        onChange={handleChange}
        extensions={[html()]}
        placeholder={placeholder}
        height={height}
        theme="light"
        basicSetup={{
          lineNumbers: true,
          foldGutter: true,
          dropCursor: false,
          allowMultipleSelections: false,
          indentOnInput: true,
          bracketMatching: true,
          closeBrackets: true,
          autocompletion: true,
          highlightSelectionMatches: false,
          searchKeymap: true,
          tabSize: 4,
        }}
        style={{
          fontSize: '14px',
          fontFamily: 'ui-monospace, SFMono-Regular, "SF Mono", Consolas, "Liberation Mono", Menlo, monospace',
          border: '1px solid #d1d5db',
          borderRadius: '8px',
          overflow: 'hidden',
        }}
      />
    </div>
  );
}

export default CodeEditor;